/**
 * Created by jacmai on 6/30/2017.
 */
define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "./variablePromptView",
  "modules/shared/responsePreview/responsePreviewModule",
  "modules/shared/adminMenu/adminMenuModule",
  "./variablePromptModel",
], function (Marionette, $, Messenger, VariablePromptView, ResponsePreviewModule, AdminMenuModule) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "variablePrompt";
      this.region = options.region;
      this._setUpVents();
    },
    save: function () {
      this.variable.saveSubModels();
    },
    show: function (variable) {
      this.variable = variable;
      this.layout = new VariablePromptView.variablePromptLayout({ model: variable });
      this.preview = this.addSubModule(new ResponsePreviewModule({ region: this.layout.response }));
      this.menu = this.addSubModule(new AdminMenuModule({ region: this.layout.menu }));
      this.layout.on("show", () =>
        variable.getValidationConstraints((constraints) =>
          this._showSubViews(variable, constraints),
        ),
      );
      this.showRegion(this.layout, { loading: true, entities: [variable, variable.prompts()] });
    },
    _showSubViews: function (_variable, constraints) {
      const menuItems = Messenger.reqres.request("prompt:menu:items", constraints);
      const menuStyle = Messenger.reqres.request("prompt:menu:style");
      this.menu.show(menuStyle, menuItems, this.name);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:" + this.name + ":missingVariable",
        function () {
          //work with missing prompts
          this.variable.setSelectedPromptType(this.variable.MISSING_PROMPT_TYPE);
          this.preview.show(this.variable);
          this.layout.setPromptTitle($.t("topics.variablePrompts.missingVariablePrompt"));
        },
        this,
      );

      Messenger.vent.on(
        "show:" + this.name + ":invalidVariable",
        function () {
          //work with invalid prompts
          this.variable.setSelectedPromptType(this.variable.INVALID_PROMPT_TYPE);
          this.preview.show(this.variable);
          this.layout.setPromptTitle($.t("topics.variablePrompts.invalidVariablePrompt"));
        },
        this,
      );

      // Purposely skipping "current:topic" to avoid something thinking that a Variable Prompt
      // is a Topic
      Messenger.reqres.setHandler("current:topic:id", () => this.variable.id);
      Messenger.reqres.setHandler("current:topic:status", () =>
        Messenger.reqres.request("default:topic:status"),
      );
    },
  });
});
